import React, { useState, useEffect, useReducer } from "react";
import { useStore, error_toast } from "../../helpers";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useParams, useLocation } from "react-router";
import { clone } from "lodash";
import { FilterButton, LoadingState } from "../../components";
import { DataNotAvailable } from "../../flexistore/renderkeys/mh-2024-field";
import { FTPPagination, FTPSearchBar } from "../../components-new";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import { doesFilterHaveValues } from "../../helpers/filterHelper";
import { Button } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SearchIcon from "@mui/icons-material/Search";
import VoiceRecorder from "../../components-new/voice-record-recognition";

const initialState = {
    loading: true,
    voterList: [],
    totalVoters: 0,
    error: "",
};

const reducer = (state, action) => {
    switch (action.type) {
        case "START":
            return {
                ...state,
                loading: true,
                error: "",
            };
        case "SUCCESS":
            return {
                loading: false,
                voterList: action.payload.results,
                totalVoters: action.payload.total,
                error: "",
            };
        case "FAILURE":
            return {
                loading: false,
                voterList: [],
                totalVoters: 0,
                error: "Something went wrong",
            };
        default:
            return state;
    }
};

export const SearchVoterList = observer((props: any) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const { projectid: pid } = useParams();
    const { pathname } = useLocation();
    const isManageVotersPage = pathname.includes("manage-voters");
    const { voterListStore, userStore } = useStore();
    const { voter_filters } = voterListStore;

    const {
        relation,
        projectid,
        page,
        house,
        genders,
        df,
        booths,
        age,
        name,
        serialno,
        voterid,
        offset,
        count,
    } = voter_filters;
    const { t } = useTranslation("voter_list");
    const clone_voter_filters = clone(voterListStore.voter_filters);

    const [pageNumber, setPageNumber] = useState(1);
    const totalPages = Math.ceil(state.totalVoters / 100);

    const ListItem = styled("li")(({ theme }) => ({
        margin: theme.spacing(0.5),
    }));

    const handlePageChange = async (
        event: React.ChangeEvent<unknown>,
        value: number
    ) => {
        setPageNumber(value);
        clone_voter_filters["offset"] = (value - 1) * count;
        await voterListStore.update_filters(clone_voter_filters);
    };

    const handleClearFilter = async (key, value) => {
        const updatedFilters = { ...clone_voter_filters }; // Clone the object to ensure a new reference

        if (Array.isArray(updatedFilters[key])) {
            // Handle array keys like genders and booths
            updatedFilters[key] = updatedFilters[key].filter(
                (item) => item !== value
            );

            if (updatedFilters[key].length === 0) {
                updatedFilters[key] =
                    key === "genders"
                        ? [t("male"), t("female"), t("third_gender")] // Default for genders
                        : [];
            }
        } else {
            updatedFilters[key] = "";
        }

        await voterListStore.update_filters(updatedFilters); // Update filters
    };

    useEffect(() => {
        getVoterList();
    }, [
        relation,
        projectid,
        page,
        house,
        genders,
        df,
        booths,
        age,
        name,
        serialno,
        voterid,
        offset,
        pid,
        count,
    ]);

    const getVoterList = async () => {
        dispatch({ type: "START" });
        clone_voter_filters["projectid"] = parseInt(pid);
        await voterListStore.update_filters(clone_voter_filters);

        try {
            const res = await voterListStore.getVoterSearch();
            userStore.setUserDetailsMode(false);
            if (res.status !== 200) {
                error_toast();
                dispatch({ type: "FAILURE" });
            } else {
                dispatch({ type: "SUCCESS", payload: res.data });
                console.log(res.data);
            }
        } catch (e) {
            dispatch({ type: "FAILURE" });
        }
    };

    const handleSearch = async (query: string) => {
        const updatedFilters = {
            ...clone_voter_filters,
            name: "",
            voterid: "",
            offset: 0,
        };

        const voterIdPattern = /^[A-Za-z]{3}\d{7}$/;
        // typical voter id pattern like ABC1234567

        if (voterIdPattern.test(query)) {
            updatedFilters.voterid = query;
        } else {
            updatedFilters.name = query;
        }

        await voterListStore.update_filters(updatedFilters);
    };

    // const handleSearchBarChange = async (value) => {
    //   clone_voter_filters["name"] = value;
    //   await voterListStore.update_filters(clone_voter_filters);
    // };

    // const getUsers = async (event, done) => {
    //   await voterListStore.update_filters({
    //     ...voter_filters,
    //     count: state.totalVoters,
    //   });
    //   done(!state.loading);
    // };

    const result = doesFilterHaveValues(voterListStore.voter_filters);

    return (
        <>
            {state["loading"] && <LoadingState />}
            {/* <div className="flex flex-col w-full gap-4 sm:items-center sm:justify-between  sm:flex-row">
        <h2 className="font-bold text-2xl text-indigo-500 ">
          Voter Management
        </h2>
        <div
          className="flex flex-col gap-4 sm:flex-row sm:items-center sm:space-x-2"
          style={{ flexFlow: "wrap" }}
        >
          <RNSearchBar onSearch={handleSearchBarChange} />
          <div className="space-x-2">
            <FilterButton
              filterOnClickHandler={() => {
                voterListStore.setShowVoterlist(false);
                voterListStore.setFilterStatus(true);
              }}
            />
            <Button
              variant={"contained"}
              onClick={async () => {
                await voterListStore.reset_filters(parseInt(pid));
              }}
              endIcon={<i className="fas fa-retweet" />}
              color={"warning"}
            >
              {t("reset_search")}
            </Button>
            {
              isAllowed && (
                <CSVLink
                  data={voterListStore.Voterlist}
                  headers={downloadColumns}
                  filename={"Voter List"}
                  asyncOnClick={true}
                  onClick={getUsers}
                >
                  <i className="text-blue-600 mx-4">Download</i>
                </CSVLink>
              )
              // <DownloadAsExcelSheet data={voterListStore.Voterlist} cols={downloadColumns} name={"Voter List"}/>
            }   
          </div>
        </div>
      </div> */}

            {/* search */}
            <div className="w-100 my-4 flex items-center justify-between">
                <div className="">
                    {isManageVotersPage && (
                        <h3 className="mb-1 text-2xl font-normal text-[1B1B1D] sm:mb-2 sm:text-3xl">
                            {t("search_voter")}
                        </h3>
                    )}
                    <span className="text-base font-normal text-[#3A3A3A]">
                        {t("search_voters_text")}
                    </span>
                </div>
            </div>

            <div className="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex w-full items-center gap-2">
                    <div className="flex-1">
                        <FTPSearchBar
                            onSearch={handleSearch}
                            placeHolder={t("Search voter name / voter ID")}
                        />
                    </div>

                    <VoiceRecorder
                        buttonLabel=""
                        onResult={async (text) => {
                            const updatedFilters = {
                                ...clone_voter_filters,
                                name: "",
                                voterid: "",
                                offset: 0,
                            };

                            const voterIdPattern = /^[A-Za-z]{3}\d{7}$/;

                            if (voterIdPattern.test(text)) {
                                updatedFilters.voterid = text;
                            } else {
                                updatedFilters.name = text;
                            }

                            await voterListStore.update_filters(updatedFilters);

                            voterListStore.setShowVoterlist(true);
                        }}
                    />
                </div>

                <div className="flex justify-end">
                    <FilterButton
                        filterOnClickHandler={() => {
                            voterListStore.setShowVoterlist(false);
                            voterListStore.setFilterStatus(true);
                        }}
                    />
                </div>
            </div>
            {result.hasValues && (
                <ul className="mb-[18px] flex w-full items-center rounded-[18px] border border-[#808080] p-2">
                    <div className="flex flex-1 items-center space-x-2">
                        <h6 className="text-xs font-normal">
                            {t("filtered_by")}:
                        </h6>
                        {result.filters.map((data) => {
                            const { key, value } = data;
                            return (
                                <>
                                    <ListItem key={key} className="space-x-2">
                                        {Array.isArray(value) ? (
                                            value.map((item, index) => (
                                                <Chip
                                                    key={`${key}-${index}`}
                                                    label={`${key}: ${item}`}
                                                    onDelete={() =>
                                                        handleClearFilter(
                                                            key,
                                                            item
                                                        )
                                                    }
                                                />
                                            ))
                                        ) : (
                                            <Chip
                                                label={`${key}: ${value}`}
                                                onDelete={() =>
                                                    handleClearFilter(
                                                        key,
                                                        value
                                                    )
                                                }
                                            />
                                        )}
                                    </ListItem>
                                </>
                            );
                        })}
                    </div>

                    <Button
                        variant="text"
                        color="error"
                        startIcon={<CloseOutlinedIcon />}
                        onClick={async () => {
                            await voterListStore.reset_filters(parseInt(pid));
                        }}
                        sx={{
                            "& .MuiButton-startIcon": {
                                marginRight: "2px",
                            },
                        }}
                    >
                        {t("Clear Filters")}
                    </Button>
                </ul>
            )}

            <div className="flex w-full flex-wrap items-center justify-between gap-4 py-5 sm:py-4">
                {state["totalVoters"] > 0 ? (
                    <div className="text-sm font-normal text-[#858585]">
                        {t("showing")}{" "}
                        <span className="text-[#1B1B1D]">{offset + 1}</span>{" "}
                        {t("to")}{" "}
                        <span className="text-[#1B1B1D]">
                            {Math.min(offset + count, state.totalVoters)}
                        </span>{" "}
                        {t("of")}{" "}
                        <span className="text-[#1B1B1D]">
                            {state.totalVoters}
                        </span>{" "}
                        {t("voter")}
                    </div>
                ) : (
                    <DataNotAvailable />
                )}

                {totalPages ? (
                    <FTPPagination
                        totalPages={totalPages}
                        pageNumber={pageNumber}
                        handlePageChange={handlePageChange}
                    />
                ) : null}
            </div>
        </>
    );
});
